import { ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  operations as assignmentOperations,
  selectors,
} from '../../../../../store/assignments';
import ConversionModal from './ConversionModal';
import { accessToken as getAccessToken } from '../../../../../../core/selectors/user';
import openSubmissionsAction from '../../../../../actions/navigation/openSubmissions.action';
import { extractStudentIdsFromErrorMessage } from '../../Assignments/utils/extractStudentsFromError';
import { LINK_ASSIGNMENT_ARIA_LABEL } from './constants';
import { AulaState } from '@core/types/state';

type ExtensionAssignment = {
  description?: string;
  endDate?: string;
  gradesReleasedAt?: string;
  gradeType?: string;
  id: string;
  isAnonymised?: boolean;
  isHidden?: boolean;
  maxGrade?: number;
  externalId?: string;
  objectId?: string;
  parentAssignmentId?: string;
  provider?: string;
  shouldCloseOnDueDate?: boolean;
  startDate?: string;
  status?: string;
  students?: string[];
  title: string;
};

const mapStateToProps = (
  state: AulaState,
  { assignmentId }: { assignmentId: string }
) => {
  const { user } = state?.user;
  const { selectedSpace: spaceId } = state?.assignments || {};
  const { groups } = state?.data?.groups || {};
  const assignment = selectors.getAssignment(state, assignmentId);
  const assignments = selectors.getAssignments(state);
  const assignmentCreationError = selectors.getAssignmentCreationError(state);
  const getSubmissions = (id: string) =>
    selectors.getAssignmentSubmissions(state, id);

  const studentIdsWithExistingSubmissions: string[] = assignmentCreationError
    ? extractStudentIdsFromErrorMessage(
        assignmentCreationError?.detail as string
      )
    : [];

  return {
    dialogTitle: LINK_ASSIGNMENT_ARIA_LABEL,
    assignment,
    unassignedStudents: selectors
      .getAssignmentSubmissions(state, assignmentId)
      .map(({ user: { id, firstName, lastName, avatar, email } }) => ({
        id,
        avatar,
        email,
        fullName: `${firstName} ${lastName}`,
      })),
    spaceGroups: Object.keys(groups)?.map((groupId) => ({
      key: groupId,
      value: groups[groupId]?.name,
      students: groups[groupId]?.students,
    })),
    spaceId,
    accessToken: getAccessToken(state, spaceId),
    user,
    assignments,
    assignmentCreationError,
    studentIdsWithExistingSubmissions,
    getSubmissions,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  convertToExtension: (
    spaceId: string,
    extension: ExtensionAssignment,
    accessToken: string
  ) =>
    dispatch(
      assignmentOperations.convertAssignmentToExtension({
        spaceId,
        assignment: {
          ...extension,
          objectId: extension.id,
          status: 'live',
        },
        accessToken,
      })
    ),
  redirectToSubmissions: (spaceId: string, assignmentId: string) =>
    dispatch(openSubmissionsAction(spaceId, assignmentId)),
  resetErrorState: () => dispatch(assignmentOperations.resetErrorState()),
  fetchSubmissions: (params: any) =>
    dispatch(assignmentOperations.fetchSubmissions(params)),
  fetchAllSubmissionsIncludingExtensions: (params: any) =>
    dispatch(
      assignmentOperations.fetchAllSubmissionsIncludingExtensions(params)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversionModal as ComponentType<any>);
